import {AnyAction} from 'redux';

const createReducer = (initialState: Object, handlers: Object) => {
  return (state = initialState, action: AnyAction) => handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state;
};

export default createReducer;
